import { makeBEM } from '../global/utils';
import { useEffect, useState } from 'react';
import Icon from '../atoms/Icon';

const Sidebar = (props) => {
    const moduleName = 'sidebar';
    const [settingsActive, setSettingsActive] = useState(false);

    const settingsBtnModifierClass = settingsActive ? 'active' : '';
    const settingsBtnClass = `btn btn--icon btn--no-border btn--setting rotate-icon-on-hover ${makeBEM(moduleName, 'settings-btn')} ${settingsBtnModifierClass}` 

    const handleSettingsBtnClick = (e) => {
        setSettingsActive(!settingsActive);
        if ( props.showSettingsViewAction ) {
            props.showSettingsViewAction();
        }
    }

    return (
        <div className={moduleName}>
            <div className={makeBEM(moduleName, 'logo-and-btn-wrapper')}>
                <button className={settingsBtnClass} onClick={handleSettingsBtnClick}>
                    <Icon size="4" name="settings" type="fill"/>
                </button>
            </div>
        </div>
    )
}

export default Sidebar;